import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminReservations = lazy(() => import("@/pages/admin/AdminReservations"));

export const Route = createFileRoute("/admin/reservations")({
  component: AdminReservations,
});
